<template>
  <v-row class="mx-2">
    <v-card class="mt-6 mx-6" v-for="(item, index) in legalItems" :key="index">
      <v-toolbar>
        <v-toolbar-title
          class="d-flex justify-star text-subtitle-1 font-weight-medium text-uppercase px-0"
          >{{ item.title }}</v-toolbar-title
        >
      </v-toolbar>
      <v-tabs vertical>
        <v-tab
          class="d-flex justify-star text-body-2 text-uppercase px-0 ml-4 mr-3"
          v-for="(subItem, index) in item.subtitles"
          :key="index"
        >
          {{ subItem.name }}
        </v-tab>

        <v-tab-item>
          <v-card flat class="mx-7">
            <v-card-text>
              <p class="d-flex justify-center text-subtitle-2">
                {{ item.paragraphs1.name }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs1.intro }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs1.t1 }} <br />
                {{ item.paragraphs1.p1 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs1.t2 }} <br />
                {{ item.paragraphs1.p2 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs1.t3 }} <br />
                {{ item.paragraphs1.p3 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs1.t4 }} <br />
                {{ item.paragraphs1.p4 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs1.t5 }} <br />
                {{ item.paragraphs1.p5 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs1.t6 }} <br />
                {{ item.paragraphs1.p6 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs1.t7 }} <br />
                {{ item.paragraphs1.p7 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs1.t8 }} <br />
                {{ item.paragraphs1.p8 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs1.t9 }} <br />
                {{ item.paragraphs1.p9 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs1.t10 }} <br />
                {{ item.paragraphs1.p10 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs1.t11 }} <br />
                {{ item.paragraphs1.p11 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs1.t12 }} <br />
                {{ item.paragraphs1.p12 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs1.t13 }} <br />
                {{ item.paragraphs1.p13 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs1.t14 }} <br />
                {{ item.paragraphs1.p14 }} <br />
                {{ item.paragraphs1.p15 }}
              </p>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat class="mx-7">
            <v-card-text>
              <p class="d-flex justify-center text-subtitle-2">
                {{ item.paragraphs2.name }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.intro1 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.intro2 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.intro3 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.t1 }} <br />
                {{ item.paragraphs2.p1 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.t2 }} <br />
                {{ item.paragraphs2.p2_1 }} <br />
                {{ item.paragraphs2.p2_2 }} <br />
                {{ item.paragraphs2.p2_3 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.t3 }} <br />
                {{ item.paragraphs2.p3 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.t4 }} <br />
                {{ item.paragraphs2.p4 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.t5 }} <br />
                {{ item.paragraphs2.p5 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.t6 }} <br />
                {{ item.paragraphs2.p6 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.t7 }} <br />
                {{ item.paragraphs2.p7 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.t8 }} <br />
                {{ item.paragraphs2.p8 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.t9 }} <br />
                {{ item.paragraphs2.p9 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.t10 }} <br />
                {{ item.paragraphs2.p10 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.t11 }} <br />
                {{ item.paragraphs2.p11 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.t12 }} <br />
                {{ item.paragraphs2.p12 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.t13 }} <br />
                {{ item.paragraphs2.p13 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.t14 }} <br />
                {{ item.paragraphs2.p14 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.t15 }} <br />
                {{ item.paragraphs2.p15 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.t16 }} <br />
                {{ item.paragraphs2.p16 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.t17 }} <br />
                {{ item.paragraphs2.p17 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.t18 }} <br />
                {{ item.paragraphs2.p18 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.t19 }} <br />
                {{ item.paragraphs2.p19 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.t20 }} <br />
                {{ item.paragraphs2.p20 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.t21 }} <br />
                {{ item.paragraphs2.p21 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.t22 }} <br />
                {{ item.paragraphs2.p22 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.t23 }} <br />
                {{ item.paragraphs2.p23 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.t24 }} <br />
                {{ item.paragraphs2.p24_1 }} <br />
                {{ item.paragraphs2.p24_2 }}
              </p>
              <p class="textJustify">
                {{ item.paragraphs2.t25 }} <br />
                {{ item.paragraphs2.p25_1 }} <br /><br />
                {{ item.paragraphs2.p25_2 }} <br />
                {{ item.paragraphs2.p25_3 }} <br />
                {{ item.paragraphs2.p25_4 }} <br />
                {{ item.paragraphs2.p25_5 }} <br />
              </p>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-row>
</template>

<script>
export default {
  name: 'VTabVertical',
  props: ['legalItems'],
  data() {
    return {};
  },
};
</script>

<style>
.textJustify {
  text-align: justify;
}
</style>
